const stackBar = (data) => {
  const defaultConfig = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {},
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: data.x
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: data.series
  };

  const opt = Object.assign({}, defaultConfig)

  return opt
}

export default stackBar